import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import { images } from '../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../Utils/helper';
import { fireExpandedEvent } from '../instrumentation';
import CategoryFilterRecursionLevel2 from './CategoryFilterRecursionLevel2';
import { FilterTitle } from './styled';

export default function CategoryFilterRecursion(props) {
  let { data, index } = props;
  const [activeIndex, setActiveIndex] = useState(-1);
  const router = useRouter();
  const expandedEvent = (item, level, index) => {
    fireExpandedEvent(item, level);
    setActiveIndex(index);
  };

  useEffect(() => {
    if (data?.isSelected) {
      setActiveIndex(index);
    }
  }, [data]);

  function getTriggerPoint(item, activeIndex, index) {
    const length = item?.subCategories?.filter(
      (category) => category.parentKey,
    )?.length;
    return (
      <Link
        href={{
          pathname: item?.key,
          query: removeDefaultParams(router.query),
        }}
        passHref
        key={`catdropdownL2${index}`}
        locale={false}
      >
        <FilterTitle className={item?.isSelected ? 'selected' : ''}>
          <span
            style={{ textTransform: 'capitalize' }}
          >{`${item.tabName?.toLowerCase()}${
            length ? ` (${length})` : ''
          }`}</span>

          {activeIndex == index ? (
            <Image
              src={images.arrowforward}
              alt={item.tabName?.toLowerCase()}
              height={16}
              width={16}
              title={item.tabName?.toLowerCase()}
            />
          ) : (
            <Image
              src={images.arrowforward}
              alt={item.tabName?.toLowerCase()}
              height={16}
              width={16}
              title={item.tabName?.toLowerCase()}
            />
          )}
        </FilterTitle>
      </Link>
    );
  }

  return (
    <Collapsible
      trigger={getTriggerPoint(data, activeIndex, index)}
      onOpen={() => expandedEvent(data, 'l2', index)}
      onOpening={() => {
        setActiveIndex(index);
      }}
      onClosing={() => {
        activeIndex == index ? setActiveIndex(-1) : null;
      }}
      open={activeIndex == index ? true : false}
      key={`catdropdownL2${index}`}
    >
      {data?.subCategories?.map((element, i) => {
        return element?.subCategories ? (
          <CategoryFilterRecursion data={element} index={i} key={i} />
        ) : element?.parentKey ? (
          <CategoryFilterRecursionLevel2 element={element} i={i} key={i} />
        ) : null;
      })}
    </Collapsible>
  );
}
